import './Layout.css';
import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import { Link, useLocation, useSearchParams, useParams, useNavigate, Outlet } from 'react-router-dom';
import NavMenu from './NavMenu';
import Welcome from './Welcome';

import { toast } from "react-toastify";
import config from "../config.json";
import useSignalR from '../useSignalR';
import http from "../Services/httpService";

import { UserProvider } from "../store/userContext";
import { MainProvider } from "../store/mainContext";

import AddDeviceUser from './AddDeviceUser'
import ChangePassword from './ChangePassword';
import ChangeProfile from './ChangeProfile'
import UserAccounts from './UserAccounts'
import CreditModal from './CreditModal';
import EditDevice from './EditDevice'
import OilChange from './OilChange'
import Report from './Report'

import noronServices from "../Services/noronServices";

export default function Layout() {
    let navigate = useNavigate();
    const [changed, setChanged] = useState(false);
    const [devices, setDevices] = useState([]);
    const [routePoint, setRoutePoint] = useState([]);
    const [defaultDevice, setDefaultDevice] = useState(null);
    const [command, setCommand] = useState("");

    const [onMessage, setOnMessage] = useState(null);
    const [doRead, setDoRead] = useState(true);
    const [updateLocation, setUpdateLocation] = useState(null);
    const [state, setState] = useState("");
    const [isPosting, setIsPosting] = useState(true);
    useEffect(() => {
        const Bale = window.Bale;
        console.log('bale', Bale)
        if (Bale?.WebApp) {

            Bale.WebApp.ready();
            Bale.WebApp.expand();
            const theme = Bale.WebApp.colorScheme;
            const bg = Bale.WebApp.backgroundColor;
            Bale.WebApp.BackButton.show();//Bale.WebApp.BackButton.hide();
            //Bale.WebApp.close();
            Bale.WebApp.BackButton.onClick(() => {
                navigate(-1);
            });
            const mainButton = Bale.WebApp.MainButton;
            mainButton.setText("دریافت گزارش");
            mainButton.show();

            mainButton.onClick(() => {
                alert('1')
            });

            Bale.WebApp.ready();
            const initData = Bale.WebApp.initData;
            console.log("initData:", initData);
            const user = Bale.WebApp.initDataUnsafe?.user;
            if (user) {
                console.log("user:", user);
                loginWithBale(initData);
            }
        }

        const jwt = http.getLocalJwt();
        if (!jwt || jwt == "") {
            navigate('/login');
            return;
        }
        const t = setTimeout(() => setIsPosting(false), 2000);
        return () => clearTimeout(t);
    }, []);


    const loginWithBale = async (data) => {
        await noronServices.AuthBale(data)
            .then(({ data }) => {
                setIsPosting(false);
                if (data.errorCode != 0) {
                    // toast.error(data.message, { theme: "colored" });
                    return
                }
                http.setLocalJwt(data.payload.token.access_token);
                http.setLocalJwtRefresh(data.payload.token.refresh_token);
                navigate('/main', { replace: true })
            })
            .catch(err => {
                setIsPosting(false);
            });
    }



    const UpdateUi = () => {
        console.log('UpdateUi');
        caches.keys().then((names) => {
            for (let name of names) caches.delete(name);
        });
    };

    const NewMessage = (data) => {
        console.log('NewMessage', data);
        toast.dark(data.message);
    };

    const ChatMessage = (data) => {
        console.log('ChatMessage', data);
        setOnMessage(data);
    };

    const CheckMessage = () => {
        console.log('CheckMessage');
        setDoRead(p => !p);
    };

    const UpdateLocation = (ime, packets) => {
        console.log(`UpdateLocation ime:${ime}`, packets);
        setUpdateLocation({ ime, packets });
    };

    const handlers = useMemo(() => ({
        UpdateLocation,
        UpdateUi,
        NewMessage,
        ChatMessage,
        CheckMessage
    }), []);

    // ----------------------------
    // SignalR Connection
    // ----------------------------

    const devicesRef = useRef(devices);
    useEffect(() => {
        devicesRef.current = devices;
    }, [devices]);

    const {
        connection,
        connectionStart,
        connectionStop
    } = useSignalR(
        `${config.signalUrl}/mapsHub?access_token=${http.getLocalJwt()}`,
        handlers,
        (con) => {
            const currentDevices = devicesRef.current;
            console.log(`✅ تلاش برای ارسال به سرور ${currentDevices.length}`, currentDevices.length > 0);
            if (currentDevices && currentDevices.length > 0) {
                console.log("✅ تلاش برای ارسال به سرور2");
                con.invoke("RequestUpdateLocation", currentDevices[0].id)
                    .then(() => {
                        console.log("✅ درخواست با موفقیت ارسال شد");
                    })
                    .catch((err) => {
                        console.error("❌ خطا در ارسال درخواست:", err);
                    });//connection.send("RequestUpdateLocation");
            }
        }
    );

    const connectionRef = useRef(null);
    useEffect(() => {
        connectionRef.current = connection;
        if (connectionRef.current) {
            setState(connectionRef.current.state);
        }
    }, [connection]);

    useEffect(() => {
        // if (connectionRef && connectionRef.current && connectionRef.current.state == "Connected")
        //   connection.send("ReportSiteConfig");
    }, [connectionRef]);

    useEffect(() => {
        setDoRead(p => !p);
    }, [state]);

    const tryReconnect = () => {
        connectionStop();
        connectionStart();
    };

    const reCreate = () => { };

    //-------------------
    const [showReport, setShowReport] = useState(false);
    const [editDeviceShow, setEditDeviceShow] = useState(false);
    const [oilChangeShow, setOilChangeShow] = useState(false);
    const [showChangePassword, setShowChangePassword] = useState(false);
    const [showAddDeviceUser, setShowAddDeviceUser] = useState(false);
    const [showChangeProfile, setShowChangeProfile] = useState(false);
    const [showCredit, setShowCredit] = useState(false);
    const [device, setDevice] = useState({});
    const [showUserAccounts, setShowUserAccounts] = useState(false);




    const handleCloseReport = (points, form) => {
        setShowReport(false);
        if (points)
            setRoutePoint(points);
        if (form)
            setDefaultDevice(form);
    }

    const editDeviceClose = (form) => {
        //e.preventDefault();
        setEditDeviceShow(false);
        //console.log('ffff',form);
        if (form != null)
            setChanged(!changed);
    }


    const OilChangeClose = () => {
        setOilChangeShow(false);
    }


    useEffect(() => {
        if (!command)
            return;
        if (command.startsWith("ShowReport")) {
            setShowReport(true);
            setCommand("");
        }
        if (command.startsWith("report")) {
            const device = command.replace("report/", "");
            const deviceFind = devices.find(({ id }) => id == device);
            setDevice(deviceFind);
            setShowReport(true);
            setCommand("");
        } else if (command.startsWith("oilChangeShow")) {
            const device = command.replace("oilChangeShow/", "");
            const deviceFind = devices.find(({ id }) => id == device);
            setDevice(deviceFind);
            setOilChangeShow(true);
            setCommand("");
        } else if (command.startsWith("EditDeviceShow")) {
            const device = command.replace("EditDeviceShow/", "");
            const deviceFind = devices.find(({ id }) => id == device);
            console.log('device', device)
            setDevice(deviceFind);
            setEditDeviceShow(true);
            setCommand("");
        } else if (command.startsWith("AddDeviceUser")) {
            setShowAddDeviceUser(true);
            setCommand("");
        }
        else if (command.startsWith("ShowChangePassword")) {
            setShowChangePassword(true);
            setCommand("");
        }
        else if (command.startsWith("ShowChangeProfile")) {
            setShowChangeProfile(true);
            setCommand("");
        }
        else if (command.startsWith("ShowCredit")) {
            setShowCredit(true);
            setCommand("");
        }
        else if (command.startsWith("ShowUserAccounts")) {
            setShowUserAccounts(true);
            setCommand("");
        }
        else if (command.startsWith("OilChangeShow")) {
            setOilChangeShow(true);
            setCommand("");
        }
        else if (command.startsWith("ShowCredit")) {
            setShowCredit(true);
            setCommand("");
        }
        else if (command.startsWith("logout")) {
            logout();
            setCommand("");
        }


    }, [command]);
    const handleCloseAddDeviceUser = (e) => {
        //e.preventDefault();
        setShowAddDeviceUser(false);
    }



    const logout = (e) => {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        http.logout();
        http.goLogin();
    };

    // ----------------------------
    // Layout with Providers
    // ----------------------------

    return (
        <UserProvider value={{
            connection,
            connectionStart,
            connectionStop,
            reconnection: tryReconnect,
            state,
            onMessage,
            doRead,
            reCreate
        }}>

            <MainProvider value={{
                changed,
                doChanged: n => setChanged(n),
                updateLocation,
                command,
                setCommand,
                devices,
                setDevices,
                defaultDevice,
                setDefaultDevice,
                routePoint,
                setRoutePoint
            }}>

                <CreditModal show={showCredit} handleClose={() => setShowCredit(false)} />
                <ChangeProfile show={showChangeProfile} handleClose={() => setShowChangeProfile(false)} />
                <ChangePassword show={showChangePassword} handleClose={() => setShowChangePassword(false)} />
                <OilChange show={oilChangeShow} handleClose={OilChangeClose} device={device} />
                <EditDevice show={editDeviceShow} handleClose={editDeviceClose} device={device} />
                <AddDeviceUser show={showAddDeviceUser} handleClose={handleCloseAddDeviceUser} />
                <Report show={showReport} handleClose={handleCloseReport} device={device} />
                {/*<ReportFuelSeason show={showReportFuelSeason} handleClose={handleCloseshowReportFuelSeason} device={device} />*/}
                <UserAccounts
                    show={showUserAccounts}
                    handleClose={setShowUserAccounts}
                    devices={devices} />



                {isPosting ? (
                    <Welcome />
                ) : (
                    <>
                        <NavMenu />
                        <div className="container-fluid">
                            <Outlet />
                        </div>
                    </>
                )}

            </MainProvider>
        </UserProvider>
    );
}
